import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';
import ConfigProvider from '../config-provider';
import { obj } from '../util';

class Placeholder extends React.Component {
  static propTypes = {
    prefix: PropTypes.string,
    /**
     * 额外的样式名 会附加到 root dom 上
     */
    className: PropTypes.string,
    /**
     * 类型
     */
    type: PropTypes.oneOf(['normal', 'mini']),
    /**
     * 占位插画
     */
    image: PropTypes.string.isRequired,
    /**
     * 占位标题
     */
    title: PropTypes.string.isRequired,
    /**
     * 占位描述
     */
    description: PropTypes.string,
  }

  static defaultProps = {
    prefix: 'next-',
    type: 'normal',
  }

  render() {
    const { prefix, className, type, image, title, description, children, ...others } = this.props;
    const classNames = cls({
      [`${prefix}placeholder`]: true,
      [`${prefix}placeholder-${type}`]: true,
      [className]: !!className,
    });
    return (
      <div className={classNames} {...obj.pickAttrs(others)}>
        <div className={`${prefix}placeholder-image`}>
          <img src={image} />
        </div>
        <div className={`${prefix}placeholder-title`}>{title}</div>
        {
          description && type === 'normal' ?
            <div className={`${prefix}placeholder-description`}>{description}</div> : null
        }
        <div className={`${prefix}placeholder-children`}>{children}</div>
      </div>
    );
  }
}

Placeholder.NO_CONTACT = '//img.alicdn.com/tfs/TB1Qn.cfuH2gK0jSZFEXXcqMpXa-162-156.png';
Placeholder.NO_TASK = '//img.alicdn.com/tfs/TB12lcbfET1gK0jSZFrXXcNCXXa-180-142.png';
Placeholder.NO_DATA = 'https://img.alicdn.com/tfs/TB19t4.BYH1gK0jSZFwXXc7aXXa-496-498.png';

const Configured = ConfigProvider.config(Placeholder);
Configured.displayName = 'Placeholder';

export default Configured;
